import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-are-you-sure-dialog',
  templateUrl: './are-you-sure-dialog.component.html',
  styleUrls: ['./are-you-sure-dialog.component.scss'],
})
export class AreYouSureDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AreYouSureDialogComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: any,
  ) {}

  close() {
    this.dialogRef.close(true);
  }
}
